import { createAction } from '@reduxjs/toolkit';
import { retailersGroupsSlice } from './reducer';

export const fetchRetailersGroups = createAction('retailersGroups/fetchRetailersGroups');

export const { receiveRetailersGroups } = retailersGroupsSlice.actions;
